<div class="flex flex-col gap-0 w-full h-full min-h-[inherit]">
    <div class="grow px-lg">
        <router-outlet (activate)="onStepRouteActivated($event)"></router-outlet>
    </div>

    <!-- This summary sheet can't be a SpartanUI sheet - those act more like dialogs, where if you click
        outside of the sheet it will close the sheet.  The summary sheet needs to be more like a slideout
        panel that stays open and allows the user to still interact with the main page -->
    <div
        #summarySheet
        data-testid="summary-sheet"
        *ngIf="showSummarySheet && summarySheetViewModel"
        class="sticky bottom-0 bg-white rounded-t-lg shadow-[0_0_10px_rgba(0,0,0,0.1)] p-lg z-6 mt-2"
    >
        <div class="flex justify-between items-center mb-lg">
            <div class="flex flex-col">
                <ng-content *ngIf="summarySheetViewModel.lineItems?.length === 1; else multipleServices">
                    <div class="text-md font-semibold">{{ summarySheetViewModel.lineItems[0].serviceName }}</div>
                    <div class="text-xs text-text-secondary">with {{ summarySheetViewModel.lineItems[0].employeeName }}</div>
                    <div class="text-xs text-text-secondary mt-xs">
                        <ng-container *ngIf="shouldShowUpToForSingleService()">
                            up to {{ getServiceLongestDuration(summarySheetViewModel.lineItems[0].serviceID) | duration }}
                        </ng-container>
                        <ng-container *ngIf="!shouldShowUpToForSingleService()">
                            {{ summarySheetViewModel.totalDuration | duration }}
                        </ng-container>
                    </div>
                </ng-content>
                <ng-template #multipleServices>
                    <div class="text-md font-semibold">{{ summarySheetViewModel.lineItems.length }} Services</div>
                    <span class="text-md text-primary-base underline cursor-pointer" (click)="summaryDetailsSheetRef()?.open()"
                        >View Details</span
                    >
                </ng-template>
            </div>
            <div class="flex items-center gap-sm">
                <div
                    class="text-sm"
                    *ngIf="summarySheetViewModel && summarySheetViewModel.lineItems && summarySheetViewModel.lineItems.length > 1"
                >
                    <ng-container *ngIf="shouldShowUpToForMultipleServices()">
                        up to {{ summarySheetViewModel.totalDuration | duration }}
                    </ng-container>
                    <ng-container *ngIf="!shouldShowUpToForMultipleServices()">
                        {{ summarySheetViewModel.totalDuration | duration }}
                    </ng-container>
                </div>
                <div
                    *ngIf="summarySheetViewModel && summarySheetViewModel.showPrices"
                    class="flex items-center rounded-sm bg-primary-light px-lg text-md font-semibold h-3xl"
                >
                    {{ summarySheetViewModel.totalPrice | dsbCurrency: currencyCode : 'symbol' : '1.0-2'
                    }}<ng-container *ngIf="isFirstAvailableEmployee() && anyServiceHasPriceException()">+</ng-container>
                </div>
                <ng-icon
                    title="Remove"
                    *ngIf="summarySheetViewModel.lineItems?.length === 1 && enableSummarySheetDelete"
                    (click)="removeService(summarySheetViewModel.lineItems[0].serviceID)"
                    class="cursor-pointer"
                    hlm
                    name="lucideTrash2"
                ></ng-icon>
            </div>
        </div>
        <button id="nextButton" class="w-full" [disabled]="!isCurrentStepValid" (click)="continue()" hlmBtn>
            {{ currentStepSummarySheetButtonText }}
        </button>
    </div>
</div>
<hlm-sheet #summaryDetailsSheet side="bottom">
    <hlm-sheet-content *brnSheetContent="let ctx" data-testid="summary-details-sheet" class="flex flex-col max-h-[85vh]">
        <hlm-sheet-header class="pl-0 flex-shrink-0">
            <h1 hlmSheetTitle>Service Details</h1>
        </hlm-sheet-header>
        <div class="flex flex-col gap-lg w-full pb-xl overflow-y-auto flex-1 min-h-0 scrollbar-hide">
            <div *ngFor="let item of summarySheetViewModel?.lineItems" class="w-full flex justify-between items-center">
                <div class="flex flex-col">
                    <div class="text-md font-semibold">{{ item.serviceName }}</div>
                    <div class="text-sm text-text-secondary">with {{ item.employeeName }}</div>
                </div>
                <div class="flex gap-md items-center">
                    <div class="text-sm">
                        <ng-container
                            *ngIf="isFirstAvailableEmployee() && serviceHasDurationException(item.serviceID); else regularItemDuration"
                        >
                            up to {{ getServiceLongestDuration(item.serviceID) | duration }}
                        </ng-container>
                        <ng-template #regularItemDuration>
                            {{ item.duration | duration }}
                        </ng-template>
                    </div>
                    <div *ngIf="summarySheetViewModel?.showPrices" class="text-sm font-semibold">
                        {{ item.price | dsbCurrency: currencyCode : 'symbol' : '1.0-2'
                        }}<ng-container *ngIf="isFirstAvailableEmployee() && serviceHasPriceException(item.serviceID)">+</ng-container>
                    </div>
                    <ng-icon
                        title="Remove"
                        *ngIf="enableSummarySheetDelete"
                        (click)="removeService(item.serviceID)"
                        class="cursor-pointer"
                        hlm
                        name="lucideTrash2"
                    ></ng-icon>
                </div>
            </div>
            <hr class="flex-shrink-0" />
            <div class="flex justify-between items-center flex-shrink-0">
                <div class="text-md font-semibold">Total</div>
                <div class="flex gap-lg items-center">
                    <div class="text-md">
                        <ng-container
                            *ngIf="isFirstAvailableEmployee() && anyServiceHasDurationException(); else regularTotalDurationDetails"
                        >
                            up to {{ summarySheetViewModel?.totalDuration | duration }}
                        </ng-container>
                        <ng-template #regularTotalDurationDetails>
                            {{ summarySheetViewModel?.totalDuration | duration }}
                        </ng-template>
                    </div>
                    <div
                        *ngIf="summarySheetViewModel?.showPrices"
                        class="flex items-center rounded-sm bg-primary-light px-lg text-md font-semibold h-3xl"
                    >
                        {{ summarySheetViewModel?.totalPrice | dsbCurrency: currencyCode : 'symbol' : '1.0-2'
                        }}<ng-container *ngIf="isFirstAvailableEmployee() && anyServiceHasPriceException()">+</ng-container>
                    </div>
                </div>
            </div>
        </div>
    </hlm-sheet-content>
</hlm-sheet>

<hlm-toaster />
